/// <amd-module name="Test/TestResultDetails/Source/TestResultSource" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import * as TestManagementService from "Test/Client/TestManagementServices";
import { IVssPageContext } from "VSS/Platform/Context";
import { TestCaseResultIdentifier } from "Test/common-util/Common";

export class TestResultSource {
    private static _instance: TestResultSource;

    private constructor () {
        this._detailedTestResultCache = {};
    }

    public resetCache() {
        this._detailedTestResultCache = {};
    }

    public static getInstance(): TestResultSource {
        if (TestResultSource._instance) {
            return TestResultSource._instance;
        }
        TestResultSource._instance = new TestResultSource();
        return TestResultSource._instance;
    }

    public getSelectedTestCaseResult(context: IVssPageContext, runId: number, resultId: number, getSubResults: boolean): Promise<TCMContracts.TestCaseResult> {
        let testCaseResultIdentifier = new TestCaseResultIdentifier(runId, resultId).toString();
        return new Promise<TCMContracts.TestCaseResult>((resolve, reject) => {
            if (this._detailedTestResultCache[testCaseResultIdentifier]) {
                resolve(this._detailedTestResultCache[testCaseResultIdentifier]);
            } else {
                let tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
                const detailsToInclude = getSubResults ? TCMContracts.ResultDetails.SubResults : TCMContracts.ResultDetails.None;
                tcmService.getResultById(runId, resultId, detailsToInclude).then((value: TCMContracts.TestCaseResult) => {
                    this._detailedTestResultCache[testCaseResultIdentifier] = value;
                    resolve(value);
                })
                .catch((reason: any) => {
                    reject(reason);
                })
            }
        });
    }

    public getTestRunById(context: IVssPageContext, runId: number, includeTags?: boolean): Promise<TCMContracts.TestRun> {
        let tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.getTestRunById(runId, true, includeTags);
    }

    private _detailedTestResultCache: any = {};
}
